{
  "uigOrgUser": {
    "header": "Alle gebruikers ({{count}})",
    "disabled": "(disabled)",
    "uid": "Email",
    "active": "Status",
    "name": "Naam",
    "firstName": "Voornaam",
    "lastName": "Achternaam",
    "email": "Email",
    "orgUnit": "Eenheid",
    "unit": "Eenheid",
    "roles": "Roles",
    "title": "Titel",
    "hint": "Alle gebruikers",
    "unitApprover": "Unit approver",
    "assignApprover": "Add the user to approvers for the unit",
    "actions": "",
    "sortBy": "Sorteren",
    "sort": {
      "byName": "Sorteren op naam",
      "byUnit": "Sorteren op ID"
    },
    "details": {
      "title": "Gebruikersdetails",
      "subtitle": "Gebruiker: {{ item.name }}"
    },
    "edit": {
      "title": "Bewerk gebruiker",
      "subtitle": "Gebruiker: {{ item.name }}"
    },
    "create": {
      "title": "Aanmaken Gebruiker",
      "subtitle": ""
    },
    "links": {
      "password": "Wachtwoord veranderen",
      "approvers": "Approvers",
      "userGroup": "User groups",
      "permission": "Purchase limits"
    },
    "messages": {
      "deactivateTitle": "Deze gebruiker uitschakelen?",
      "deactivate": "Gehandicapte gebruikers kunnen niet inloggen op de etalage en bestellingen plaatsen.",
      "deactivateBody": "Gehandicapte gebruikers kunnen niet inloggen op de etalage en bestellingen plaatsen.",
      "confirmEnabled": "User {{item.firstName}} {{item.lastName}} enabled successfully",
      "confirmDisabled": "User {{item.firstName}} {{item.lastName}} disabled successfully",
      "update": "Gebruiker {{item.firstName}} {{item.lastName}} succesvol geactualiseerd",
      "create": "Gebruiker {{item.firstName}} {{item.lastName}} succesvol geregistreerd",
      "updatePassword": "Het wachtwoord is succesvol gewijzigd voor gebruiker {{item.firstName}} {{item.lastName}}.",
      "deleteUser": {
        "title": "Deze gebruiker uitschakelen?",
        "content": "Weet u zeker dat u deze gebruiker wilt verwijderen?",
        "confirm": "Bevestig",
        "deleteConfirmation": "Gebruiker succesvol verwijderd"
      }
    },
    "info": {
      "disabledEdit": "Bearbeitungsmodus ist nur möglich, wenn Sie den Benutzer aktivieren",
      "disabledEnable": "Unit must be enabled before this user may be enabled."
    },
    "approver": {
      "link": "Approvers",
      "header": "Approvers in {{code}}",
      "assign": "Assign Approvers",
      "assignHeader": "Assign Approvers in {{code}}",
      "back": "Back",
      "new": "New approver",
      "instructions": {
        "check": "To assign an approver to this user, select the user's check box.",
        "uncheck": "To remove an approver, clear the user's check box.",
        "changes": "Changes are saved automatically."
      }
    },
    "userGroup": {
      "link": "User groups",
      "header": "User groups in {{code}}",
      "assign": "Assign user groups",
      "assignHeader": "Assign user groups in {{code}}",
      "back": "Back",
      "instructions": {
        "check": "To assign an user group to this user, select the user's check box.",
        "uncheck": "To remove aa user group, clear the user's check box.",
        "changes": "Changes are saved automatically."
      }
    },
    "permission": {
      "link": "Purchase limits",
      "header": "Purchase limits in {{code}}",
      "assign": "Assign purchase limits",
      "assignHeader": "Assign purchase limits in {{code}}",
      "back": "Back",
      "instructions": {
        "check": "To assign a purchase limits to this user, select its check box.",
        "uncheck": "To unassign a purchase limits, clear its check box.",
        "changes": "Changes are saved automatically."
      },
      "per": {
        "undefined": "",
        "MONTH": "per Month",
        "YEAR": "per Year",
        "WEEK": "per Week",
        "QUARTER": "per Quarter"
      }
    },
    "password": {
      "title": "Wachtwoord veranderen",
      "subtitle": "Gebruiker: {{ item.email }}",
      "newPassword": "Neues Passwort",
      "confirmPassword": "Neues Passwort wiederholen"
    },
    "breadcrumbs": {
      "list": "Alle gebruikers",
      "details": "{{name}}",
      "userGroups": "User groups",
      "approvers": "Approvers",
      "permissions": "Purchase limits"
    }
  }
}
